import { LEAD_SOURCE, APARTMENT_DROPDOWN } from "./type";

const initalState = {
  LeadSources: [],
  appartmentDropDown: {},
};

const LeadDetailsReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LEAD_SOURCE:
      return {
        ...state,
        LeadSources: payload,
      };
    case APARTMENT_DROPDOWN:
      return {
        ...state,
        appartmentDropDown: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default LeadDetailsReducer;
